export const Env = () => {
    let apiUrl = process.env.REACT_APP_PROD_URL;
    if (process.env.NODE_ENV === "development") {
        apiUrl = process.env.REACT_APP_LOCAL_URl;
    }
    return apiUrl;
};
